module.exports = __webpack_public_path__ + "static/media/close-icon.dbcf5803.svg";